/**
 * Centralized z-index hierarchy for the application.
 *
 * Use with inline styles: style={{ zIndex: Z_INDEX.FLOATING_ACTION_BAR }}
 * (Tailwind purges dynamic `z-[${value}]` classes at build time, so a shared
 * constant is safer than computed class names.)
 *
 * Only layers that are actually consumed live here — add a constant when you
 * wire it, not speculatively.
 */
export const Z_INDEX = {
  /** Table sticky pinned columns — body cells (2) sit under the header row (12). */
  TABLE_STICKY: 2,
  /**
   * Sticky bottom totals footer (LR-469). Sits ABOVE the body pinned cells (2)
   * so a scrolling row passes under it, and BELOW the sticky header row (12) —
   * the two never overlap vertically, but keeping the footer lower keeps the
   * header's drop-shadow on top if they ever meet on a one-row table.
   */
  TABLE_STICKY_FOOTER: 3,
  TABLE_STICKY_HEADER: 12,

  /** Floating action bar at the bottom of the trades page. */
  FLOATING_ACTION_BAR: 100,
} as const;
